import React from "react";
import windowsIcon from "../../assets/images/windows.svg";
import androidIcon from "../../assets/images/android.svg";
import linuxIcon from "../../assets/images/linux.svg";
import Tooltip from "@material-ui/core/Tooltip";

const getOSTooltip = (os) => {
  switch (os) {
    case 'windows':
      return (
        <Tooltip title="Windows" placement="right">
          <img width="20" height="20" src={windowsIcon} alt="Windows Icon" />
        </Tooltip>
      );
    case 'android':
      return (
        <Tooltip title="Android" placement="right">
          <img width="20" height="20" src={androidIcon} alt="Android Icon" />
        </Tooltip>
      );
    case 'linux':
      return (
        <Tooltip title="Linux" placement="right">
          <img width="20" height="20" src={linuxIcon} alt="Linux Icon" />
        </Tooltip>
      );
    default:
      return null;
  }
};

const OSType = ({ os }) => {
  return <div className="os_area">{getOSTooltip(os)}</div>;
};

export default OSType;
